import { createContext, useState } from "react";

const LiveDataContext = createContext({});

export const LiveDataProvider = ({ children }) => {
  const [liveData, setLiveData] = useState();

  function liveOfDevice(deviceId) {
    if (!liveData || !liveData?.devices) return null;
    return liveData?.devices[deviceId];
  }

  function statusOfDevice(deviceId) {
    if (!liveData || !liveData?.devices || !liveData?.devices[deviceId]) return null;
    return liveData?.devices[deviceId].status;
  }

  function registersOfDevice(deviceId) {
    if (!liveData || !liveData?.devices || !liveData?.devices[deviceId]) return null;
    return liveData?.devices[deviceId].registers;
  }

  function meteringOfDevice(deviceId) {
    if (!liveData || !liveData?.devices || !liveData?.devices[deviceId]) return null;
    return liveData?.devices[deviceId].metering;
  }

  function tsOfDevice(deviceId) {
    if (!liveData || !liveData?.devices || !liveData?.devices[deviceId]) return null;
    return liveData?.devices[deviceId].timestamp;
  }

  return (
    <LiveDataContext.Provider
      value={{
        liveData,
        setLiveData,
        liveOfDevice,
        statusOfDevice,
        meteringOfDevice,
        registersOfDevice,
        tsOfDevice,
      }}
    >
      {children}
    </LiveDataContext.Provider>
  );
};

export default LiveDataContext;
